export const STATUS = [
  'default',
  'applied',
  'error'
]
